import { generateToastId } from "./generate-toast-id";
var TYPE = "BASIC_TOAST";
/** Checks if bus message is of a Toast type */
export var isBasicToastMessage = function isBasicToastMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};

/**
 * Create a new basic toast message
 * @param type Select one of the predefined types of toast
 */
export var basicToastMessage = function basicToastMessage(type) {
  return {
    type: TYPE,
    payload: {
      id: generateToastId(),
      type: type
    }
  };
};